<template>
  <RfStatusEnabled v-if="status === StatusesConstants.running.type" />
  <RfStatusPaused v-else-if="status === StatusesConstants.paused.type" />
  <RfStatusDisabled v-else-if="status === StatusesConstants.ended.type" />
  <RfStatusLimited v-else-if="status === StatusesConstants.limited.type" />
  <RfStatusPending v-else-if="status === StatusesConstants.pending.type" />
  <RfStatusScheduled v-else-if="status === StatusesConstants.ready.type" />
</template>

<script setup>
import RfStatusDisabled from "@/components/statuses/RfStatusDisabled.vue";
import RfStatusEnabled from "@/components/statuses/RfStatusEnabled.vue";
import RfStatusPaused from "@/components/statuses/RfStatusPaused.vue";
import RfStatusLimited from "@/components/statuses/RfStatusLimited.vue";
import RfStatusPending from "@/components/statuses/RfStatusPending.vue";
import RfStatusScheduled from "@/components/statuses/RfStatusScheduled.vue";
import StatusesConstants from "@/utils/constants/PromptStatusesConstants";

defineProps({ status: { type: String, default: StatusesConstants.pending.type } });
</script>
